<template>
    <div>
        <div class="table-layout">
            <el-table :data="auditRecList" border maxHeight="400" ref="dataTable" tooltip-effect="dark" style="width: 100%">
                <el-table-column align="center" prop="auditTime" label="操作时间" width="160"></el-table-column>
                <el-table-column align="left" prop="auditBizUnitName" label="部门" width="200" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.auditorDepartFullName != null">{{rows.row.auditorDepartFullName}}</span>
                        <span v-else>{{rows.row.auditBizUnitName}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="left" prop="auditorPostName" label="岗位" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="auditorName" label="操作人" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="auditDesc" label="审核描述" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import devcApi from '../../api/devc'

    export default{
        name: 'swb-devc-split-audit-rec-list',
        desc: '拆分单审核记录',
        props: ["id"],
        data: function () {
            return {
                auditRecList: []
            }
        },
        created: function () {
            if(!Utils.isNoB(this.id)) {
                this.getAuditRecList();
            }
        },
        methods: {
            // 获取审核记录列表
            getAuditRecList: function () {
                let self = this;
                //
                let params = {};
                params.formId = self.id;
                let msgBoxDlg = MsgBox.loading();
                devcApi.getDevcSplitAuditRecList(params, function (result) {
                    msgBoxDlg.close();
                    if(result.type == 'info') {
                        let auditRecList = result.data || [];
                        self.auditRecList = Utils.merge({}, auditRecList);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/devcSplit/DevcSplitAuditRecList.vue